<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in job category value here"
                  append-icon="search"
                  label="Search Job Category"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Job Category's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-job-categories-dialog-create
                  v-if="$hasPermissionTo(['create job categories'])" 
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredJobCategories"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>{{ item.name }}</span>
              </div>
            </template>
           
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-job-categories-dialog-edit
                  v-if="$hasPermissionTo(['update job categories'])" 
                  :job-category="item"
                  @updated="loadData"
                />
                <span class="mx-1" />
                <setup-job-categories-dialog-delete
                  v-if="$hasPermissionTo(['delete job categories'])" 
                  :job-category="item"
                  @deleted="loadData"
                />
              </span>
              <span v-else>
                <setup-job-categories-dialog-restore
                  v-if="$hasPermissionTo(['delete job categories'])" 
                  :job-category="item"
                  @restored="loadData"
                />
              </span>
            </template> 
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>     
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupJobCategoriesDialogCreate: () => import('@/components/setup/job/categories/DialogCreate'),
      SetupJobCategoriesDialogDelete: () => import('@/components/setup/job/categories/DialogDelete'),
      SetupJobCategoriesDialogRestore: () => import('@/components/setup/job/categories/DialogRestore'),
      SetupJobCategoriesDialogEdit: () => import('@/components/setup/job/categories/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Job Categories',
      }
    },
    data () {
      return {
        jobCategories: [],
        trashedJobCategories: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredJobCategories () {
        return this.statusFilter ? this.jobCategories : this.trashedJobCategories
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobCategories().list(),
          this.$api.jobCategories().listTrashed(),
        ]).then(([jobCategories, trashedJobCategories]) => {
          this.jobCategories = jobCategories.data
          this.trashedJobCategories = trashedJobCategories.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
